enum Mutations {
  SET_CARERECEIVER_PROFILE = 'setCarereceiverProfile',
  SET_CARERECEIVER_FROM_BE = 'setCareReceiverFromBE',
  SET_CARERECEIVER_ID_FOR_CURRENT_BOOKING_FUNNEL = 'setCareReceiverIdForCurrentBookingFunnel',
}

export default Mutations
